import { ClientProfile } from "~/components/client/profile/profile";
import PageMeta from "~/components/common/meta";

export function Profile() {
  return (
    <>
      <PageMeta title={`Profile | Art Handler`} />
      <ClientProfile />
    </>
  );
}

